<script lang="ts" module>
    import BookingDetail from "./view/pages/BookingDetail.svelte";
  import Dashboard from "./view/pages/Dashboard.svelte";
    import GameDetailPage from "./view/pages/GameDetailPage.svelte";
    import GamesOverview from "./view/pages/GamesOverview.svelte";
  import Impressum from "./view/pages/Impressum.svelte";
  import Privacy from "./view/pages/Privacy.svelte";
  import Error404__SvelteComponent_ from "./view/pages/error404.svelte";
  import BookSlot from "./view/pages/BookSlot.svelte"
    import Bookings from "./view/pages/Bookings.svelte";
    import BookingRequest from "./view/pages/BookingRequest.svelte";
    import SlotDetail from "./view/pages/SlotDetail.svelte";
    import Slots from "./view/pages/Slots.svelte";
    import PromptEngineering from "./view/pages/PromptEngineering.svelte";
    import SlotCreate from "./view/pages/SlotCreate.svelte";

  export const routes = {
    // "/listings": ListingCardGridViewSvelte,
    "/": Dashboard,
    "/games": GamesOverview,
    "/game/:id": GameDetailPage,
    "/game/:id/slot/:copySlotId": SlotCreate,
    "/game/:id/slot": SlotCreate,
    "/booking/:id": BookingDetail,
    "/bookingrequest/:id": BookingRequest,
    "/bookings": Bookings,
    "/book/slot/:id": BookSlot,
    "/promptengineering/slot/:id": PromptEngineering,
    "/privacy": Privacy,
    "/slots": Slots,
    "/slot/:id": SlotDetail,
    "/impressum": Impressum,
    // "/checkout/success/:checkoutSessionId": PaymentSuccessView,
    // "/checkout/cancel/:checkoutSessionId": PaymentCancelView,
    // "/tokens": TokenCardGridView,
    // "/tokens/:userId": TokenCardGridView,
    "*": Error404__SvelteComponent_,
  };
</script>
